import { Container } from './styles';

const Version = () => {
  const { REACT_APP_VERSION } = process.env;

  return <Container>v {REACT_APP_VERSION}</Container>;
};

export default Version;
